import Immutable, { Record } from 'immutable';

const ActivityItemRecord = Record({
  cicActivityItemId: undefined,
  cicActivityItemCode: undefined,
  orderingSequence: undefined,
  isChecked: true,
});

class ActivityItem extends ActivityItemRecord { }

const reviver = ([key, val]) => {
  switch (key) {
    case 'cicActivityItemCode':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

ActivityItem.create = (data) =>
  new ActivityItem(data).mapEntries(reviver);

export default ActivityItem;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Activity/ActivityItem/model.js